<template>
  <div class="">
    <va-text-input
      class="time-input"
      v-model="initialTime"
      label="Time to show first toast (ms)"
      required
      type="number"
      @input="updateInitialTime(initialTime)" />
    <va-array-input
      v-model="toastsData"
      v-slot="props"
      :label="false"
      :hide-details="'auto'"
      add-button-text="Add Toast">
      <VaMediaObjectFileInput
        :key="props.index + imageFieldUniqKey"
        label="Toast image"
        class="mb-4 w-full"
        v-bind="props"
        :item-id="toastsData[props.index].imageID"
        @update:photo="updatePicture($event, props.index)" />

      <va-tinymce-input
        :key="props.index + bodyTextFieldUniqKey"
        class="mb-4 w-full"
        :current-content="toastsData[props.index].bodyText"
        :editor-height="120"
        only-b-i-u-s
        v-bind="props"
        title="Toast body text"
        @update="content => updateBodyText(content, props.index)" />

      <va-tinymce-input
        :key="props.index + timeTextFieldUniqKey"
        class="mb-4 w-full"
        :current-content="toastsData[props.index].timeText"
        :editor-height="120"
        only-b-i-u-s
        v-bind="props"
        title="Toast time text"
        @update="content => updateTimeText(content, props.index)" />
    </va-array-input>
  </div>
</template>

<script>
  import { v4 as uuidv4 } from "uuid";
  import definedAbility from "@/ability";
  import { TOAST_INITIAL_TIME } from "@/constant/index";

  const DEFAULT_TOAST = {
    id: 1,
    imageID: "",
    imageURL: "",
    bodyText: "",
    timeText: "",
  };
  export default {
    data() {
      return {
        toastsData: [DEFAULT_TOAST],
        initialTime: TOAST_INITIAL_TIME,
        imageFieldUniqKey: uuidv4(),
        bodyTextFieldUniqKey: uuidv4(),
        timeTextFieldUniqKey: uuidv4(),
        ability: definedAbility(),
      };
    },
    watch: {
      toastsData: {
        handler(newValue) {
          this.updateValue(newValue);
        },
        deep: true,
      },
    },
    beforeMount() {
      this.setupReceiveDataListener();
      this.requestData();
    },
    methods: {
      updateValue(val) {
        window.parent.postMessage(
          {
            mceAction: "updateToastData",
            data: JSON.stringify(val),
          },
          origin,
        );
      },
      updateInitialTime(val) {
        window.parent.postMessage(
          {
            mceAction: "updateInitialTime",
            time: JSON.stringify(val),
          },
          origin,
        );
      },
      updatePicture(value, index) {
        if (value === "") {
          this.toastsData[index].imageID = "";
          this.toastsData[index].imageURL = "";

          this.updateValue(this.toastsData);
        } else {
          this.toastsData[index].imageID = value["@id"];
          if (this.ability.can("upload", "media object to inulti server")) {
            this.toastsData[index].imageURL = process.env.VUE_APP_API + value.contentUrl;
          } else {
            this.toastsData[index].imageURL = value.contentUrl;
          }

          this.updateValue(this.toastsData);
        }
      },
      updateBodyText(content, index) {
        this.toastsData[index].bodyText = content;

        this.updateValue(this.toastsData);
      },
      updateTimeText(content, index) {
        this.toastsData[index].timeText = content;

        this.updateValue(this.toastsData);
      },
      setupReceiveDataListener() {
        window.onmessage = message => {
          if (message.data.type === "sendData") {
            const { data } = message.data;
            const { time } = message.data;
            //Set default values if user exits toast window without saving (prevents JSON error)
            if (time === "undefined") {
              this.updateInitialTime(this.initialTime);
            } else {
              this.initialTime = JSON.parse(time);
            }
            if (data === "undefined") {
              this.updateValue(this.toastsData);
            } else {
              this.toastsData = JSON.parse(data);
            }
          }
        };
      },
      requestData() {
        window.parent.postMessage(
          {
            mceAction: "requestData",
          },
          origin,
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .va-array-input__actions-wrapper {
      top: calc(50% + 14px);
      transform: translateY(-50%);
    }

    .va-array-input__item-wrapper {
      flex-direction: column !important;
      &:not(:first-child) {
        border-bottom: 2px dotted;
      }
    }
  }

  .time-input {
    padding: 19px 25px 0 14px;
    margin-bottom: 16px;
  }
</style>
